var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectDebitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/empty-wallet-change"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 13.74V12.01C3 9.94001 4.68999 8.25 6.75999 8.25H18.24C20.31 8.25 22 9.94001 22 12.01V13.45H19.98C19.42 13.45 18.91 13.67 18.54 14.05C18.12 14.46 17.88 15.05 17.94 15.68C18.03 16.76 19.02 17.55 20.1 17.55H22V18.74C22 20.81 20.31 22.5 18.24 22.5H12.76",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 12.9103V8.34035C3 7.15035 3.73 6.0903 4.84 5.6703L12.78 2.6703C14.02 2.2003 15.35 3.12033 15.35 4.45033V8.25032",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.0588 14.4702V16.5302C23.0588 17.0802 22.6188 17.5302 22.0588 17.5502H20.0988C19.0188 17.5502 18.0288 16.7602 17.9388 15.6802C17.8788 15.0502 18.1188 14.4602 18.5388 14.0502C18.9088 13.6702 19.4188 13.4502 19.9788 13.4502H22.0588C22.6188 13.4702 23.0588 13.9202 23.0588 14.4702Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.5 17H8.84C9.48 17 10 17.52 10 18.16V19.44",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.72 15.7803L3.5 17.0002L4.72 18.2202",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10 22.2798H4.66C4.02 22.2798 3.5 21.7598 3.5 21.1198V19.8398",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.78125 23.5005L10.0013 22.2806L8.78125 21.0605",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDebitIcon);
export default __webpack_public_path__ + "static/media/direct_debit_icon.16def78cc55e91da1532ef918fbb8a65.svg";
export { ForwardRef as ReactComponent };